import { PromotionRow } from "src/components/promotions";
import { DateService, _ } from "src/services";
import { DayCardProps } from "./day.card.props";
import { ProgramCard } from "./program.card";
import { Card, ListGroup } from "react-bootstrap";
import GameDate from "src/components/ProgramList/GameDate";
import Game from "src/components/ProgramList/Game";
import Competition from "src/components/ProgramList/Competition";
import ListsCard from "src/components/ProgramList/ListsCard";

export const DayCard: React.FC<DayCardProps> = ({
  date,
  items,
  persianDate,
  mainIndex,
}) => {
  return (
    <>
      <Card
        style={{
          backgroundColor: "#1C1C1C",
          borderStyle: "hidden",
          boxShadow: "none",
        }}
      >
        {!(
          mainIndex === 0 &&
          !items.filter((other) => other.program?.status === 1).length
        ) && <GameDate georgianDate={persianDate} />}
        <ListGroup
          horizontal
          style={{ overflow: "auto", textAlign: "right", marginTop: 0 }}
          className={
            mainIndex === 0 ? "activeRow selectableRow" : "selectableRow"
          }
        >
          {items
            .filter((x, i) => mainIndex !== 0 || x.program?.status === 1)
            .map((item, index: number) => (
              <ListsCard
                cover={item.program?.cover}
                programId={item.program?.id}
                startAt={new Date(item.program?.startAt!).toLocaleTimeString(
                  "fa-ir",
                  {
                    minute: "2-digit",
                    hour: "2-digit",
                  }
                )}
                title={item.program?.title!}
                upperTitle={item.program?.upperTitle}
                status={item.program?.status}
                liveBadgeText={item.program?.liveBadgeText}
                id={item.program?.id}
                key={index}
              />
            ))}
        </ListGroup>
      </Card>
    </>
  );
};
